import React, { Component } from 'react'
import { withFirebase } from '../../config'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Confirm } from 'semantic-ui-react'
import { Redirect } from 'react-router-dom';

/*Redux */
import 'firebase/firestore'
import 'firebase/auth'
import { connect } from 'react-redux'
import propTypes from 'prop-types'
/*Actions */
import {
    deleteBookParent,
    fetchAllBookParent,
    emptyError
} from '../../Actions/BookParentAction'
import { ALL_BOOK_PARENTS } from '../../routes';


class DeleteBookParent extends Component {

    state = { open: false }

    open = () => this.setState({ open: true })
    close = () => this.setState({ open: false })


    deleteBookParent(id) {
        this.props.deleteBookParent(id);
    }


    handleSubmit = (e) => {

        const { id } = this.props;

        console.log("id = " + id)

        this.deleteBookParent(id);
        this.close();

    }


    render() {
        const { error } = this.props;
        const { success } = this.props;

        if (success === false) {
            alert("error missing data or network " + error)
            this.props.emptyError();

        }
        else if (success === true) {
            alert("Parent Book Deleted Successfully")
            this.props.emptyError();
            this.props.fetchAllBookParent();
            return (<Redirect to={ALL_BOOK_PARENTS}></Redirect>)
        }

        return (
            <div >
                <button className="seriesCardButtons" onClick={this.open}>
                    <i>
                        <FontAwesomeIcon icon="trash-alt" />
                    </i>
                </button>
                <Confirm id="modal"
                    content='Are you sure you want to delete this Parent Book ??'
                    open={this.state.open} onCancel={this.close} onConfirm={this.handleSubmit} />
            </div>

        )
    }
}


DeleteBookParent.propTypes = {
    deleteBookParent: propTypes.func.isRequired,

}
const mapStateToProps = state => ({
    error: state.bookParent.deleting_book_parent_error,
    success: state.bookParent.deleting_book_parent_sucessfully
});

export default withFirebase(
    connect
        (mapStateToProps,
            {
                fetchAllBookParent,
                deleteBookParent,
                emptyError
            })
        (DeleteBookParent));
